<template>
  <quick-actions class='modules-widget' title='Where you left off' :widgets='pendingActivities' :items='learningModules.length > 0 ? [learningModules] : []' :is_loading='loading' :uses_custom_widget='pendingActivities.length == 0'>
    <template slot='widget' slot-scope="{ widget }">
      <div class="quick-actions__widget quick-actions__widget--cta-with-icon">
        <span class="kf-stack kf-stack--circle">
          <i class="kf kf-circle-outline"></i>
          <i class='kf'
             :class="activityIconClass(widget)"></i>
        </span>
        <div class="quick-actions__widget__subtitle">Up Next</div> 
        <div class="module-widget__title typo__title--strong">"{{ widget.title }}"</div>
        <a class="btn--sm btn--x-dark btn--outline"
           :href="widget.is_accessible ? widget.link : 'javascript:;'"
           @click='showNavigationWarning(widget)'>Go to {{ widget.type }}</a>
      </div>
    </template>
    <template slot='custom_widget'>
      <div class='quick-actions__widget_holder learning-modules__completed'>
        <div class="quick-actions__widget quick-actions__widget--cta-with-icon">
          <div>
            <i class='kf kf-checkmark-circle'></i>
            <div class="quick-actions__widget__subtitle">You're all caught up!</div> 
          </div>
        </div>
      </div>
    </template>
    <template slot="item">
      <div class="module-item">
        <carousel :perPage='learningModules.length > 4 ? 4 : learningModules.length'
                  :paginationEnabled='false'
                  ref='carousel'>
          <slide v-for='(module, modIndex) in learningModules'
                 class='learning-module__slide'
                 :class='[
                   modIndex == 0 ? "first" : "",
                   modIndex == learningModules.length - 1 ? "last" : ""
                 ]'
                 :key="modIndex">
            <div class="module-item__activities-container">
              <div v-for="(activity, i) in shownActivities(module)"
                   :class="[
                     'module-item__activity',
                     (i == 0) ? 'last' : '',
                   ]"
                   :key='i'>
                <a :href='activity.is_accessible ? activity.link : "javascript:;"'
                   @click='showNavigationWarning(activity)'>
                  <span class='kf-stack kf-stack--circle'
                        :class="[
                          (i == 0) ? 'last' : '',
                          activity.is_completed ? 'completed' : '',
                        ]"
                        v-tooltip='{content: activity.title, arrow: true}'>
                    <i class='kf kf-circle-outline'></i>
                    <i class='kf'
                       :class='activityIconClass(activity)'></i>
                  </span>
                </a>
              </div>
              <div class="module-item__activity"
                   v-if='module.activities.length > 3'
                   v-tooltip="{ template: 'templates/tooltips/student/home/learning-modules/overflow', templateParams: { activities: module.activities.slice(3)}, position: 'right' }">
                +{{ module.activities.length - 3  }}
              </div>
            </div>
            <div class='module-item__progress-section'
                :class='[progress[modIndex] == "100%"? "completed" : ""]'>
              <span class="quick-actions__widget__progress"
                    :style='{width: progress[modIndex] || "0"}'>
              </span>
            </div>
            <div class="module-title__holder">
              <p class='typo__body--reg'>{{ module.title }}</p>
            </div>
          </slide>
        </carousel>
        <a class="kd-ibtn module__prev"
           :class="[firstPage ? 'is-disabled' : '']"
           href="javascript:;"
           @click='prev' >
          <i class="kf kf-arrow-thin kf-rotate-180"></i>
        </a>
        <a class="kd-ibtn module__next"
           :class="[lastPage ? 'is-disabled' : '']"
           href="javascript:;"
           @click='next' >
          <i class="kf kf-arrow-thin"></i>
        </a>
      </div>
    </template>
  </quick-actions>
</template>

<script>
import {Carousel, Slide} from 'vue-carousel';


export default {
  components: {
    Carousel, Slide
  },
  data() {
    return {
      learningModules: [],
      pendingActivities: [],
      completedCount: 0,
      courseId: null,
      modulePage: 0,
      firstPage: true,
      lastPage: false,
      activeModule: 0,
      loading: true,
    }
  },
  mounted() {
    this.courseId = Kadenze.Util.getCourseIdFromPath()
    new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.current_progress_course_path(this.courseId),
    }).done((data) => {
      console.log(data)
      this.learningModules = data.learning_modules
      this.pendingActivities = data.pending_activities
      this.completedCount = data.completed_count
      this.loading = false;
      this.$nextTick(() => {
        const activePage = Math.floor(this.activeModule / 4)
        if (activePage) {
          this.$refs.carousel.goToPage(activePage)
        }
      })
    }) 
  },
  computed: {
    moduleIndex() {
      return this.modulePage * 4;
    },
    shownModules() {
      return this.learningModules.slice(this.moduleIndex, this.moduleIndex+4);
    },
    progress() {
      const progArr = [];
      let lastModCompleted = true;
      let lmIndex = 0;
      let module = this.learningModules[lmIndex]
      while(lastModCompleted && module) {
        if ( module.is_completed ) {
          progArr[lmIndex] = '100%';
          progArr[lmIndex + 1] = '50%';
        } else {
          if (_.some(module.activities, a => a.is_completed)) {
            if ( lmIndex == this.learningModules.length - 1 ) {
              progArr[lmIndex] = '75%';
            } else {
              progArr[lmIndex] = '100%';
            }
          } else if ( lmIndex == 0 ) {
            progArr[lmIndex] = '50%';
          }
          lastModCompleted = false;
        }
        this.activeModule = lmIndex;
        lmIndex++;
        module = this.learningModules[lmIndex];
      }
      return progArr;
    }
  },
  methods: {
    activityClassMapping(activity) {
      return {
        'Session': 'lecture',
        'Lecture': 'lecture',
        'Resource': 'resources',
        'Coursework': 'coursework'
      }[activity.type];
    },
    activityIconClass(activity) {
      return `kf-${this.activityClassMapping(activity)}`;
    },
    prev() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
      this.updateCarouselNav();
    },
    next() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
      this.updateCarouselNav();
    },
    updateCarouselNav() {
      this.firstPage = this.$refs.carousel.currentPage === 0;
      this.lastPage = this.$refs.carousel.currentPage === (this.$refs.carousel.pageCount - 1);
    },
    shownActivities(lm) {
      return lm.activities.slice(0, 3);
    },
    showNavigationWarning(activity) {
      if (!activity.is_accessible) {
        new Kadenze.Notice.info({
          title: 'Uh Oh',
          message: `You will need to go back and complete activities in the prior module before you can access this ${activity.type}`
        })
      }
    }
  }
}
</script>
